import { type CalendarEventColor } from "./types";

// =============================================================================
// Static Tailwind literals only (never interpolated, so Tailwind sees them).
// "brand" follows the back-office signal tokens, the others stay muted so the
// page keeps its black & white dominant.
// =============================================================================

type EventColorClasses = {
  /** Block / bar container: soft background, saturated text and border */
  base: string;
  /** Small dot (popovers, overflow list) */
  dot: string;
};

const EVENT_COLOR_CLASSES: Record<CalendarEventColor, EventColorClasses> = {
  brand: {
    base: "border-signal-line bg-signal-soft text-signal hover:bg-signal-soft-hover",
    dot: "bg-brand",
  },
  green: {
    base: "border-emerald-500/30 bg-emerald-500/12 text-emerald-700 hover:bg-emerald-500/18 dark:text-emerald-300",
    dot: "bg-emerald-500",
  },
  amber: {
    base: "border-amber-500/35 bg-amber-500/14 text-amber-800 hover:bg-amber-500/20 dark:text-amber-200",
    dot: "bg-amber-500",
  },
  gray: {
    base: "border-line bg-surface-3 text-muted-foreground hover:text-foreground",
    dot: "bg-muted-foreground",
  },
  blue: {
    base: "border-sky-500/30 bg-sky-500/12 text-sky-800 hover:bg-sky-500/18 dark:text-sky-200",
    dot: "bg-sky-500",
  },
};

export function getEventColorClasses(
  color: CalendarEventColor = "brand"
): EventColorClasses {
  return EVENT_COLOR_CLASSES[color];
}
